/**
 * @generated SignedSource<<227c25357c4f62028ac51cf5f1db5d85>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamScheduleRoutineListItemContent_RoutineOccasion$data = {
  readonly assigned: ReadonlyArray<{
    readonly employee: {
      readonly id: string;
    } | null;
  }>;
  readonly assignedRoles: ReadonlyArray<{
    readonly role: {
      readonly id: string;
    };
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"RoutineOccasionListItemAssignedEmployees_RoutineOccasion">;
  readonly " $fragmentType": "TeamScheduleRoutineListItemContent_RoutineOccasion";
};
export type TeamScheduleRoutineListItemContent_RoutineOccasion$key = {
  readonly " $data"?: TeamScheduleRoutineListItemContent_RoutineOccasion$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleRoutineListItemContent_RoutineOccasion">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamScheduleRoutineListItemContent_RoutineOccasion",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AssignedEmployee",
      "kind": "LinkedField",
      "name": "assigned",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Employee",
          "kind": "LinkedField",
          "name": "employee",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AssignedRole",
      "kind": "LinkedField",
      "name": "assignedRoles",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EmployeeRole",
          "kind": "LinkedField",
          "name": "role",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoutineOccasionListItemAssignedEmployees_RoutineOccasion"
    }
  ],
  "type": "RoutineOccasion",
  "abstractKey": null
};
})();

(node as any).hash = "3a4f8915675fbfd7e21963e402ce7f05";

export default node;
